import { useState, useCallback, useRef, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Button, Modal } from 'react-bootstrap';
import useCommonStore from 'store/common';
import InstaStory from 'components/InstaStory';
import { Pagination } from 'swiper/modules';
import { S3_SMALL_THUMB, S3_URL } from 'constants';
import 'swiper/css';
import { isMobileOnly } from 'react-device-detect';
import { getFileName } from 'utils';

const SocialStoryPreview = () => {
	const [activeSlide, setActiveSlide] = useState(0);
	const swiperRef: any = useRef(null);

	const goToNextSlide = () => {
		if (swiperRef.current && swiperRef.current.swiper) {
			swiperRef.current.swiper.slideNext();
		}
	};

	const goToPreviousSlide = () => {
		if (swiperRef.current && swiperRef.current.swiper) {
			swiperRef.current.swiper.slidePrev();
		}
	};

	const customSlideChange = (index: number) => {
		if (index >= activeSlide) {
			goToNextSlide();
		} else {
			goToPreviousSlide();
		}
	};

	const { modalConfig = {} }: any = useCommonStore((state) => state);
	const { data: mediaData = [], id: sliderId = null } = modalConfig;

	const handleSlideChange = useCallback((swiper: any) => {
		setActiveSlide(swiper.activeIndex);
	}, []);

	const pagination = {
		clickable: true,
		renderBullet: function (index: number, className: string) {
			const media = mediaData[index]?.story[0];
			const imgSrc =
				media?.mediaType === 'video'
					? S3_SMALL_THUMB + getFileName(media?.mediaItem)
					: S3_URL + media?.mediaItem;

			return `<span class=${className}><Image src=${imgSrc} loading='lazy' /></span>`;
		},
	};

	return (
		<Modal.Body className="d-flex align-items-center justify-content-center">
			<Button
				className="close-btn rounded-circle fw-bold position-absolute lh-1"
				onClick={() => {
					modalConfig?.onClose();
				}}
			>
				<i className="ri-close-line"></i>
			</Button>

			<div className="story-preview-slider w-100">
				<div className="container">
					<Swiper
						ref={swiperRef}
						spaceBetween={isMobileOnly ? 0 : 10}
						slidesPerView={isMobileOnly ? 1 : 3}
						onSlideChange={handleSlideChange}
						centeredSlides={true}
						className="story-Swiper"
						onSwiper={handleSlideChange}
						initialSlide={sliderId || 0}
						pagination={pagination}
						modules={[Pagination]}
						breakpoints={{
							992: {
								slidesPerView: 3,
							},
							300: {
								slidesPerView: 1,
							},
						}}
					>
						{mediaData?.length > 0 &&
							mediaData?.map((storyGroup: any, index: number) => (
								<SwiperSlide key={index}>
									{({ isActive }) => (
										<div
											tabIndex={0}
											role="button"
											style={{ outline: 'none' }}
											className="story-preview-box position-relative"
										>
											{storyGroup?.story?.length > 0 && (
												<InstaStory
													isActive={isActive}
													storyData={storyGroup}
													slideLength={mediaData?.length}
													activeSlide={activeSlide}
													goToNextSlide={goToNextSlide}
													customSlideChange={customSlideChange}
													slideIndex={index}
												/>
											)}
										</div>
									)}
								</SwiperSlide>
							))}
					</Swiper>
				</div>
			</div>
		</Modal.Body>
	);
};

export default SocialStoryPreview;
